<template>
  <v-app>
    <v-container fluid>
      <v-form @submit.prevent="submitForm">
        <v-row>
          <!-- LEFT : MASTER SALES CONTACT INFO -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel" >
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Master Sales Contact Information
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-row dense class="mt-3 px-3">
                    <v-col cols="12" md="3">
                      <v-date-input
                        label="Invoice Date*"
                        
                        v-model="invoice_date"
                        :error-messages="errors.invoice_date"
                        density="compact"
                        variant="outlined"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Invoice No*"
                        v-model="invoice_no"
                        :error-messages="errors.invoice_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Contact No"
                        v-model="contact_no"
                        :error-messages="errors.contact_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Purchase Order No"
                        v-model="purchase_order_no"
                        :error-messages="errors.purchase_order_no"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Buyer*"
                        v-model="buyer_id"
                        :items="buyerList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.buyer_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Beneficiary Bank*"
                        v-model="beneficiary_bank_id"
                        :items="bankList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.beneficiary_bank_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Buyer Bank*"
                        v-model="buyer_bank_id"
                        :items="bankList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.buyer_bank_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Total Amount*"
                        type="number"
                        v-model.number="total_amount"
                        :error-messages="errors.total_amount"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Advance Payment Type*"
                        v-model="advance_payment_type"
                        :items="['percent', 'flat']"
                        :error-messages="errors.advance_payment_type"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Advance Payment Value*"
                        type="number"
                        v-model.number="advance_payment_value"
                        :error-messages="errors.advance_payment_value"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Advance Payment Amount*"
                        type="number"
                        v-model.number="advance_payment_amount"
                        :error-messages="errors.advance_payment_amount"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Before Shipment Payment Type*"
                        v-model="before_shipment_payment_type"
                        :items="['percent', 'flat']"
                        :error-messages="errors.before_shipment_payment_type"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Before Shipment Payment Value*"
                        type="number"
                        v-model.number="before_shipment_payment_value"
                        :error-messages="errors.before_shipment_payment_value"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                        label="Before Shipment Payment Amount*"
                        type="number"
                        v-model.number="before_shipment_payment_amount"
                        :error-messages="errors.before_shipment_payment_amount"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Currency*"
                        v-model="currency_id"
                        :items="currencyList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.currency_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Incoterm*"
                        v-model="incoterm_id"
                        :items="incotermList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.incoterm_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Payment Term*"
                        v-model="payment_term_id"
                        :items="paymentTermList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.payment_term_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Loading Port*"
                        v-model="loading_port_id"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.loading_port_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Discharge Port*"
                        v-model="discharge_port_id"
                        :items="portList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.discharge_port_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Shipping Method*"
                        v-model="shipping_method_id"
                        :items="shippingMethodList"
                        item-title="name"
                        item-value="id"
                        :error-messages="errors.shipping_method_id"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-date-input
                        label="Expiry Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar"
                        variant="outlined"
                        clearable
                        v-model="expiry_date"
                        :error-messages="errors.expiry_date"
                      ></v-date-input>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Partial Shipment"
                        v-model="partial_shipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.partial_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Early Shipment"
                        v-model="early_shipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.early_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-select
                        label="Transhipment Shipment"
                        v-model="transhipment_shipment"
                        :items="[
                            { label: 'Allowed', value: 'allowed' },
                            { label: 'Not Allowed', value: 'not_allowed' }
                        ]"
                        item-title="label"
                        item-value="value"
                        :error-messages="errors.transhipment_shipment"
                        density="compact"
                        variant="outlined"
                        clearable
                      />
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-textarea
                        label="Additional Condition"
                        v-model="additional_condition"
                        :error-messages="errors.additional_condition"
                        rows="3"
                        density="compact"
                        variant="outlined"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>

          <!-- RIGHT : DETAILS BREAKDOWN -->
          <v-col cols="12" md="12">
            <v-expansion-panels v-model="panel1" multiple>
              <v-expansion-panel>
                <v-expansion-panel-title class="panel-header" color="blue-grey-lighten-4">
                  Details
                </v-expansion-panel-title>

                <v-expansion-panel-text>
                  <v-card flat>
                    <v-card-text  style="overflow-y: auto; white-space: nowrap;">
                      <table class="dep-table order-table mt-4 custome-table">
                        <thead>
                          <tr>
                            <th class="table-header-cel" v-for="col in headers" :key="col.value">{{ col.text }}</th>
                            <th class="table-header-cel">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-for="(row, rowIndex) in tableData" :key="row.id" :class="{ 'error-row': tableErrors[rowIndex] }">
                            <td v-for="(col, colIndex) in headers" :key="col.value">
                              <v-text-field
                                style="min-width: 150px;"
                                v-if="!['ex_factory_date', 'etd_date','quantity', 'unit_price', 'total_amount'].includes(col.value) && col.value !== 'currency_id'"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                :type="['quantity', 'unit_price', 'total_amount'].includes(col.value) ? 'number' : 'text'"
                                dense
                                hide-details
                                variant="outlined"
                                :error-messages="tableErrors[rowIndex]?.[col.value]"
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                @input="calculateTotal(rowIndex)"
                              />

                               <v-text-field
                                style="min-width: 100px;"
                                v-if="['quantity', 'unit_price', 'total_amount'].includes(col.value) && col.value !== 'currency_id'"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                :type="['quantity', 'unit_price', 'total_amount'].includes(col.value) ? 'number' : 'text'"
                                dense
                                hide-details
                                variant="outlined"
                                :error-messages="tableErrors[rowIndex]?.[col.value]"
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                @input="calculateTotal(rowIndex)"
                              />

                              <v-date-input
                                v-if="['ex_factory_date', 'etd_date'].includes(col.value)"
                                style="height:30px !important; min-width: 150px;"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                variant="outlined"
                                density="compact"
                                prepend-icon=""
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                                clearable
                              />

                              <v-select
                                style="min-width: 150px;"
                                v-if="col.value === 'currency_id'"
                                class="breakdown-input"
                                v-model="row[col.value]"
                                :items="currencyList"
                                item-title="name"
                                item-value="id"
                                dense
                                hide-details
                                variant="outlined"
                                :error-messages="tableErrors[rowIndex]?.[col.value]"
                                @keydown.enter.prevent="focusNextCell(rowIndex, colIndex)"
                                @keydown.tab.prevent="focusNextCell(rowIndex, colIndex)"
                              />
                            </td>
                            <td style="width:65px;">
                              <v-btn v-if="(rowIndex != tableData.length - 1) || (tableData.length > 1)" icon variant="tonal" size="small" color="primary" class="pa-1 breakdown-input" @click="removeRow(rowIndex)">
                                <v-icon color="red">mdi-close</v-icon>
                              </v-btn>

                              <v-btn v-if="rowIndex == tableData.length - 1" variant="tonal" icon size="small" color="primary" class="breakdown-input" @click="addRow">
                                <v-icon color="blue">mdi-plus</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                      <v-btn class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                      <v-btn class="bg-primary" @click="submitForm(1)">
                        {{ isEdit ? 'Update' : 'Save' }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";

const store = useStore();
const route = useRoute();
const router = useRouter();
const masterSalesContactId = route.params.id;

const headers = [
  { text: "PO", value: "po" },
  { text: "Style No", value: "style_no" },
  { text: "Description", value: "description" },
  { text: "HS Code", value: "hs_code" },
  { text: "Composition", value: "composition" },
  { text: "Color Name", value: "color_name" },
  { text: "Size Range", value: "size_range" },
  { text: "Quantity", value: "quantity" },
  { text: "Unit Price", value: "unit_price" },
  { text: "Total Amount", value: "total_amount" },
  { text: "Currency", value: "currency_id" },
  { text: "Ex Factory Date", value: "ex_factory_date" },
  { text: "ETD Date", value: "etd_date" },
  { text: "Destination", value: "destination" },
];

const panel = ref([0]);
const panel1 = ref([0]);
const isEdit = ref(false);

// Master fields
const invoice_date = ref(null);
const invoice_no = ref("");
const contact_no = ref("");
const purchase_order_no = ref("");
const buyer_id = ref(null);
const beneficiary_bank_id = ref(null);
const buyer_bank_id = ref(null);
const total_amount = ref(0);
const advance_payment_type = ref("percent");
const advance_payment_value = ref(0);
const advance_payment_amount = ref(0);
const before_shipment_payment_type = ref("percent");
const before_shipment_payment_value = ref(0);
const before_shipment_payment_amount = ref(0);
const currency_id = ref(null);
const incoterm_id = ref(null);
const payment_term_id = ref(null);
const loading_port_id = ref(null);
const discharge_port_id = ref(null);
const shipping_method_id = ref(null);
const expiry_date = ref(null);
const partial_shipment = ref(null);
const early_shipment = ref(null);
const transhipment_shipment = ref(null);
const additional_condition = ref("");

// Lists
const buyerList = computed(() => store.getters.getCustomerList || []);
const bankList = computed(() => store.getters.getLcBankList || []);
const currencyList = computed(() => store.getters.getCurrencyList || []);
const incotermList = computed(() => store.getters.getLcIncotermList || []);
const paymentTermList = computed(() => store.getters.getLcPaymentTermList || []);
const portList = computed(() => store.getters.getLcPortList || []);
const shippingMethodList = computed(() => store.getters.getLcShippingMethodList || []);

const tableData = reactive([]);
const errors = reactive({});
const tableErrors = reactive({});

function addRow() {
  const newId = tableData.length ? tableData[tableData.length - 1].id + 1 : 1;
  const row = { 
    id: newId,
    po: "",
    style_no: "",
    description: "",
    hs_code: "",
    composition: "",
    color_name: "",
    size_range: "",
    quantity: 0,
    unit_price: 0,
    total_amount: 0,
    currency_id: null,
    ex_factory_date: null,
    etd_date: null,
    destination: "",
  };
  tableData.push(row);
  nextTick(() => focusCell(tableData.length - 1, 0));
}

function removeRow(index) {
  if (tableData.length > 1) {
    tableData.splice(index, 1);
  }
}

function calculateTotal(rowIndex) {
  const row = tableData[rowIndex];
  if (row.quantity && row.unit_price) {
    row.total_amount = parseFloat(row.quantity) * parseFloat(row.unit_price);
  } else {
    row.total_amount = 0;
  }
}

function focusNextCell(rowIndex, colIndex) {
  const totalRows = tableData.length;
  const totalCols = headers.length;

  let nextRow = rowIndex;
  let nextCol = colIndex + 1;

  if (nextCol >= totalCols) {
    nextCol = 0;
    nextRow++;
    if (nextRow >= totalRows) {
      addRow();
      nextRow = totalRows;
    }
  }

  focusCell(nextRow, nextCol);
}

function focusCell(rowIndex, colIndex) {
  nextTick(() => {
    const table = document.querySelector("table");
    const row = table?.rows[rowIndex + 1];
    if (row) {
      const cell = row.cells[colIndex]?.querySelector("input, select");
      if (cell) cell.focus();
    }
  });
}

const detailSchema = yup.object({
  po: yup.string().required("PO required"),
  style_no: yup.string().required("Style no required"),
  quantity: yup.number().typeError("Quantity must be number").required().positive(),
  unit_price: yup.number().typeError("Unit price must be number").required().min(0),
  total_amount: yup.number().required(),
  currency_id: yup.number().required("Currency required"),
});

const schema = yup.object({
  invoice_date: yup.date().required("Invoice date required"),
  invoice_no: yup.string().required("Invoice no required"),
  buyer_id: yup.number().required("Buyer required"),
  beneficiary_bank_id: yup.number().required("Beneficiary bank required"),
  buyer_bank_id: yup.number().required("Buyer bank required"),
  total_amount: yup.number().required(),
  advance_payment_type: yup.string().required(),
  advance_payment_value: yup.number().required(),
  advance_payment_amount: yup.number().required(),
  before_shipment_payment_type: yup.string().required(),
  before_shipment_payment_value: yup.number().required(),
  before_shipment_payment_amount: yup.number().required(),
  currency_id: yup.number().required("Currency required"),
  incoterm_id: yup.number().required("Incoterm required"),
  payment_term_id: yup.number().required("Payment term required"),
  loading_port_id: yup.number().required("Loading port required"),
  discharge_port_id: yup.number().required("Discharge port required"),
  shipping_method_id: yup.number().required("Shipping method required"),
  details: yup.array().of(detailSchema).min(1),
});

async function getInitialData() {
  try {
    // Load customer list for buyers
    if (store.getters.getCustomerList.length === 0) {
      await store.dispatch("getCustomerList", {});
    }
    
    // Load LC bank list for beneficiary and buyer banks
    if (store.getters.getLcBankList.length === 0) {
      await store.dispatch("getLcBankList", {});
    }
    
    // Load currency list
    if (store.getters.getCurrencyList.length === 0) {
      await store.dispatch("getCurrencyList");
    }
    
    // Load LC incoterm list
    if (store.getters.getLcIncotermList.length === 0) {
      await store.dispatch("getLcIncotermList");
    }
    
    // Load LC payment term list
    if (store.getters.getLcPaymentTermList.length === 0) {
      await store.dispatch("getLcPaymentTermList");
    }
    
    // Load LC port list (for loading and discharge ports)
    if (store.getters.getLcPortList.length === 0) {
      await store.dispatch("getLcPortList");
    }
    
    // Load LC shipping method list
    if (store.getters.getLcShippingMethodList.length === 0) {
      await store.dispatch("getLcShippingMethodList");
    }
    
    if (masterSalesContactId) {
      isEdit.value = true;
      // Load existing data
      await store.dispatch("getMasterSalesContact", masterSalesContactId).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          invoice_date.value = data.invoice_date;
          invoice_no.value = data.invoice_no;
          contact_no.value = data.contact_no || "";
          purchase_order_no.value = data.purchase_order_no || "";
          buyer_id.value = data.buyer_id;
          beneficiary_bank_id.value = data.beneficiary_bank_id;
          buyer_bank_id.value = data.buyer_bank_id;
          total_amount.value = data.total_amount;
          advance_payment_type.value = data.advance_payment_type;
          advance_payment_value.value = data.advance_payment_value;
          advance_payment_amount.value = data.advance_payment_amount;
          before_shipment_payment_type.value = data.before_shipment_payment_type;
          before_shipment_payment_value.value = data.before_shipment_payment_value;
          before_shipment_payment_amount.value = data.before_shipment_payment_amount;
          currency_id.value = data.currency_id;
          incoterm_id.value = data.incoterm_id;
          payment_term_id.value = data.payment_term_id;
          loading_port_id.value = data.loading_port_id;
          discharge_port_id.value = data.discharge_port_id;
          shipping_method_id.value = data.shipping_method_id;
          expiry_date.value = data.expiry_date;
          partial_shipment.value = data.partial_shipment;
          early_shipment.value = data.early_shipment;
          transhipment_shipment.value = data.transhipment_shipment;
          additional_condition.value = data.additional_condition || "";

          // Load details
          if (data.details && data.details.length > 0) {
            tableData.splice(0, tableData.length);
            data.details.forEach((detail) => {
              tableData.push({
                id: detail.id,
                po: detail.po,
                style_no: detail.style_no,
                description: detail.description || "",
                hs_code: detail.hs_code || "",
                composition: detail.composition || "",
                color_name: detail.color_name || "",
                size_range: detail.size_range || "",
                quantity: detail.quantity,
                unit_price: detail.unit_price,
                total_amount: detail.total_amount,
                currency_id: detail.currency_id,
                ex_factory_date: detail.ex_factory_date,
                etd_date: detail.etd_date,
                destination: detail.destination || "",
              });
            });
          }
        }
      });
    } else {
      addRow();
    }
  } catch (error) {
    console.error("Error loading data:", error);
  }
}

async function submitForm(status) {
  Object.keys(errors).forEach(k => delete errors[k]);
  Object.keys(tableErrors).forEach(k => delete tableErrors[k]);

  const payload = {
    invoice_date: invoice_date.value,
    invoice_no: invoice_no.value,
    contact_no: contact_no.value,
    purchase_order_no: purchase_order_no.value,
    buyer_id: buyer_id.value,
    beneficiary_bank_id: beneficiary_bank_id.value,
    buyer_bank_id: buyer_bank_id.value,
    total_amount: total_amount.value,
    advance_payment_type: advance_payment_type.value,
    advance_payment_value: advance_payment_value.value,
    advance_payment_amount: advance_payment_amount.value,
    before_shipment_payment_type: before_shipment_payment_type.value,
    before_shipment_payment_value: before_shipment_payment_value.value,
    before_shipment_payment_amount: before_shipment_payment_amount.value,
    currency_id: currency_id.value,
    incoterm_id: incoterm_id.value,
    payment_term_id: payment_term_id.value,
    loading_port_id: loading_port_id.value,
    discharge_port_id: discharge_port_id.value,
    shipping_method_id: shipping_method_id.value,
    expiry_date: expiry_date.value,
    partial_shipment: partial_shipment.value,
    early_shipment: early_shipment.value,
    transhipment_shipment: transhipment_shipment.value,
    additional_condition: additional_condition.value,
    status,
    details: tableData.map(row => ({
      po: row.po,
      style_no: row.style_no,
      description: row.description || null,
      hs_code: row.hs_code || null,
      composition: row.composition || null,
      color_name: row.color_name || null,
      size_range: row.size_range || null,
      quantity: parseFloat(row.quantity),
      unit_price: parseFloat(row.unit_price),
      total_amount: parseFloat(row.total_amount),
      currency_id: row.currency_id,
      ex_factory_date: row.ex_factory_date || null,
      etd_date: row.etd_date || null,
      destination: row.destination || null,
    })),
  };

  try {
    await schema.validate(payload, { abortEarly: false });
    if (isEdit.value) {
      await store.dispatch("updateMasterSalesContact", { id: masterSalesContactId, data: payload });
      toast.success("Updated Successfully");
    } else {
      await store.dispatch("saveMasterSalesContact", payload);
      toast.success("Saved Successfully");
    }
    router.push({ name: "master-sales-contact-record" });
  } catch (err) {
    err.inner.forEach(e => {
      if (e.path && e.path.startsWith("details")) {
        const match = e.path.match(/details\[(\d+)\]\.(.+)/);
        if (match) {
          const rowIndex = match[1];
          const field = match[2];

          if (!tableErrors[rowIndex]) tableErrors[rowIndex] = {};
          tableErrors[rowIndex][field] = e.message;
        }
      } else {
        errors[e.path] = e.message;
      }
    });
  }
}

onMounted(getInitialData);
</script>

<style>
.panel-header {
  background: #eceff1;
  font-weight: 600;
}

.breakdown-input .v-field {
  min-height: 32px !important;
  height: 32px !important;
  border: none !important;
  border-radius: 0px !important;
}

.breakdown-input .v-field .v-field__input {
  min-height: 32px !important;
  height: 32px !important;
  padding: 2 !important;
  font-size: 12px;
}

.breakdown-input input {
  min-height: 32px !important;
  height: 32px !important;
  max-height: 32px !important;
}

.custome-table {
  width: 100% !important;
  border-collapse: collapse;
}

.custome-table th,
.custome-table td {
  border: 1px solid #c0c0c0;
  text-align: left;
}

.custome-table th {
  background-color: #eceff1;
  font-weight: 600;
}

.table-header-cel {
  text-align: center !important;
  height: 30px;
  font-size: 12px;
}

.v-btn--icon {
  height: 30px !important;
  width: 30px !important;
}

.error-row {
  background: #fff3f3;
}
</style>

